"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgKeyFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25.79 6.29c-4-4-7.8-4.26-11.29-.78l-.08.07a8.54 8.54 0 00-2.16 8.64l-9.17 8.34V29H8.4l1.6-1.59V25h2.9v-3h2.5l2.33-2.24a8.47 8.47 0 008.83-2.18A7.16 7.16 0 0029 12.5c0-2.02-1-4.06-3.21-6.21zM20.59 14a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z" })));
}
exports.default = SvgKeyFilled;
//# sourceMappingURL=KeyFilled.js.map